import { twMerge } from 'tailwind-merge'

const variants = {
  primary: 'bg-gradient-to-br from-white to-slate-100/90 text-black',
  action: 'bg-gradient-to-br from-white to-slate-100/70 text-primary',
  outline: 'border-[2px] bg-white/10 hover:bg-white/50  border-white/30 border-b-[px] text-white/80',
  discreet: 'border-white/10 hover:bg-white/5 *:muted= *:hover:unmuted=',
  naked: 'bg-gradient-to-t from-primary/10 hover:bg-zinc-500/0 border-primary/30 border-t-[2px] border-b-[px]  text-white font-semibold',
  destructive: 'bg-zinc-800 text-red-600'
}

const ButtonUI = ({
  className,
  children,
  variant,
  disabled,
  onClick,
  type = 'button',
  ...props
}) => {

  const handleClick = () => {
    if(!onClick) return
    else onClick()
  }
  return (
    <button
      onClick={handleClick}
      type={type}
      className={twMerge(
        'relative flex justify-center items-center active:scale-[.95] active:origin-bottom disabled:opacity-30 px-3 py-1 border border-transparent rounded-lg w-fit min-w-[44px] max-w-64= min-h-[44px] !font-arial text-[.75rem]= !tracking-wide hover:scale-[.98]= whitespace-nowrap transition disabled:cursor-not-allowed overflow-hidden =quicker',
        className,
        variants[variant]
      )}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  )
}

export default ButtonUI
